/**
 * @generated SignedSource<<98c5f64088f18c3926016788e102d4fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StreamInviteRowUninviteMutation$variables = {
  id: string;
  inviteId: string;
};
export type StreamInviteRowUninviteMutation$data = {
  readonly noteStreamUninvite: {
    readonly noteStream: {
      readonly id: string;
      readonly pendingStreamInvites: ReadonlyArray<{
        readonly email: string;
        readonly id: string;
      }> | null;
    };
  } | null;
};
export type StreamInviteRowUninviteMutation = {
  response: StreamInviteRowUninviteMutation$data;
  variables: StreamInviteRowUninviteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "inviteId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "inviteId",
        "variableName": "inviteId"
      }
    ],
    "concreteType": "NoteStreamUninvite",
    "kind": "LinkedField",
    "name": "noteStreamUninvite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamInvite",
            "kind": "LinkedField",
            "name": "pendingStreamInvites",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamInviteRowUninviteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StreamInviteRowUninviteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7136556628283838cbd3bd943836a020",
    "id": null,
    "metadata": {},
    "name": "StreamInviteRowUninviteMutation",
    "operationKind": "mutation",
    "text": "mutation StreamInviteRowUninviteMutation(\n  $id: ID!\n  $inviteId: ID!\n) {\n  noteStreamUninvite(id: $id, inviteId: $inviteId) {\n    noteStream {\n      id\n      pendingStreamInvites {\n        id\n        email\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "633f9e161fb35172d6f7009f5f8bb0ec";

export default node;
